export default __webpack_public_path__ + "static/media/alexa4.7df7144f.webp";